import {gql} from '@apollo/client';

export interface GetLastPlanningAssignTypeDetailRequest {
    warehouseId: number;
    areaId: number;
}

export interface LastPlanningAssignTypeDetailOutput {
    /** 外层每个元素代表一个分段，内层是该分段的邮编列表 */
    zipcodeList: string[][];
    /** 外层每个元素代表一个分段，内层是该分段的多边形字符串数组，每个字符串格式 "lat,lng;lat,lng;..." */
    fenceList: string[][];
}

export interface GetLastPlanningAssignTypeDetailResponse {
    getLastPlanningAssignTypeDetail: LastPlanningAssignTypeDetailOutput;
}

export interface GetLastPlanningAssignTypeDetailVariables {
    request: GetLastPlanningAssignTypeDetailRequest;
}

export const GET_LAST_PLANNING_ASSIGN_TYPE_DETAIL_FOR_DSP = gql`
    query GetLastPlanningAssignTypeDetailForDsp($request: GetLastPlanningAssignTypeDetailRequestInput!) {
        getLastPlanningAssignTypeDetailForDsp(request: $request) {
            zipcodeList
            fenceList
        }
    }
`;

export const GET_LAST_PLANNING_ASSIGN_TYPE_DETAIL = gql`
    query GetLastPlanningAssignTypeDetail($request: GetLastPlanningAssignTypeDetailRequestInput!) {
        getLastPlanningAssignTypeDetail(request: $request) {
            zipcodeList
            fenceList
        }
    }
`;
